<script>
	import { fly } from 'svelte/transition';
	import { RedirectToStep, bq, flyParams, pageState } from 'Routes/reservation-de-groupe/store';
	import { onMount } from 'svelte';
	import { goto } from '$app/navigation';
	import { DatePicker } from 'date-picker-svelte';
	import { locale_dates } from '$lib/backoffice/backoffice_store';

	let ready = false;

	onMount(() => {
		ready = true;
	});
</script>

<div
	class="gbm-date-container"
	in:fly|local={{ ...flyParams.in }}
	out:fly|local={{ ...flyParams.out }}
>
	<div style="max-width: 100%; display:flex; justify-content: center;">
		{#if ready}
			<DatePicker
				bind:value={$bq.date}
				min={new Date()}
				max={new Date(new Date().setFullYear(new Date().getFullYear() + 5))}
				locale={$locale_dates()}
				on:select={$pageState.next}
			/>
		{/if}
	</div>
</div>

<style>
	.gbm-date-container {
		grid-column: 1/2;
		grid-row: 1/2;
		display: grid;
		place-items: center;
	}
	:global(.gbm-date-container .date-time-picker) {
		box-shadow: none !important;
		border: 0 !important;
		background: none !important;
		color: var(--font-color) !important;
		font-size: calc(var(--font-size) * 0.9) !important;
		width: 100%;
		padding: 0 !important;
	}
	:global(.gbm-date-container .date-time-picker select) {
		background: none !important;
		border: none !important;
		color: var(--font-color) !important;
	}
	:global(.gbm-date-container .date-time-picker select:focus + select.dummy-select) {
		box-shadow: none !important;
	}
	:global(.gbm-date-container .date-time-picker .cell.selected) {
		border: none !important;
		border-radius: 50% !important;
		background-color: var(--secondary) !important;
		color: var(--font-color-secondary) !important;
		font-weight: 600 !important;
	}
	:global(.gbm-date-container .date-time-picker .cell:hover) {
		border: none !important;
		border-radius: 50% !important;
		/* background-color: var(--primary) !important;
		color: var(--font-color-primary) !important; */
	}
	:global(.gbm-date-container .date-time-picker .cell.today) {
		border-radius: 50% !important;
	}
	:global(.gbm-date-container .date-time-picker .cell) {
		height: 2.8em !important;
		width: 2.8em !important;
		font-size: 0.9em !important;
		box-sizing: border-box !important;
	}
	:global(.gbm-date-container .date-time-picker .page-button svg) {
		fill: var(--font-color) !important;
	}
</style>
